import { initializeApp } from 'firebase/app';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getAnalytics } from 'firebase/analytics';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyA3GwFJL9kSwGAMSbmV0_Ax5WBq165FQdY",
  authDomain: "mr-graph-nexus-ai.firebaseapp.com",
  projectId: "mr-graph-nexus-ai",
  storageBucket: "mr-graph-nexus-ai.appspot.com",
  messagingSenderId: "705874037724",
  appId: "1:705874037724:web:71122139348685f4761d19",
  measurementId: "G-29JGW12JX6"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Auth with explicit settings
const auth = getAuth(app);
auth.useDeviceLanguage();
auth.settings.appVerificationDisabledForTesting = false;

// Initialize other services
export const analytics = getAnalytics(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

export { auth };
export default app; 